import { Toaster } from '@/components/ui/shadcn/sonner';
import AppLayoutTemplate from '@/layouts/app/app-sidebar-layout';
import { useFlashToasts } from '@/lib/flash-toasts';
import { type BreadcrumbItem } from '@/types';
import { type ReactNode } from 'react';

interface AppLayoutProps {
    children: ReactNode;
    breadcrumbs?: BreadcrumbItem[];
}

export default ({ children, breadcrumbs, ...props }: AppLayoutProps) => {
    useFlashToasts();
    return (
        <AppLayoutTemplate breadcrumbs={breadcrumbs} {...props}>
            {children}
            <Toaster visibleToasts={5} />
        </AppLayoutTemplate>
    );
};
